export default { sha: '5e135a4345b5dc982c505aeacb4a7c3ddf86e332', buildNumber: 'undefined' }
